module.exports = __webpack_public_path__ + "static/media/diamond-1.81fdee7e.png";